import React, { useEffect, useMemo } from "react";
import s from "./ContactButtons.module.scss";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { getContactLinks } from "../../redux/InformationSlice";
import { buildContactLinksMap } from "../../utils/contactLinks";

const ContactButtons = () => {
  const dispatch: AppDispatch = useDispatch();
  const contactLinks = useSelector((state: RootState) => state.info.contactLinks);
  const { t } = useTranslation();

  useEffect(() => {
    if (!contactLinks?.length) {
      dispatch(getContactLinks());
    }
  }, [dispatch, contactLinks]);

  const items = useMemo(
    () => [
      {
        code: "consultant",
        title: t("Я консультант"),
        icon: "/images/Vector.svg",
      },
      { code: "jurist", title: t("Я юрист"), icon: "/images/Vector2.svg" },
      { code: "ai", title: t("Я ИИ"), icon: "/images/Vector3.svg" },
    ],
    [t],
  );
  const links = useMemo(() => buildContactLinksMap(contactLinks), [contactLinks]);

  return (
    <div className={s.content}>
      <div className={s.buttons}>
        {items.map((it) => {
          const href = links[it.code];
          return (
            <a
              key={it.code}
              className={s.btn}
              href={href || "#"}
              target={href ? "_blank" : undefined}
              rel={href ? "noreferrer noopener" : undefined}
              aria-disabled={!href}
              onClick={(e) => {
                if (!href) e.preventDefault();
              }}
            >
              <div className={s.img}>
                <img src={it.icon} className={s.btn_icon} alt="" />
              </div>

              <div className={s.text}>
                <div className={s.btn_title}>{it.title}</div>
                <div className={s.btn_subtitle}>{t("Задать вопрос")}</div>
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default ContactButtons;
